import { Component, Injectable, OnInit, ViewChild } from '@angular/core';

import { CallHistoryReportComponent } from '../../../../app/home/paraEmpresas/reports/callHistory/content.component';
import { AlertService } from '../../../../app/utils/alert.service';
import { BindComponentService } from '../../../../app/utils/bind.component.service'; // ALTERADO

import * as moment from 'moment';

/**
 * @version $Id: content.component.ts 92888 2018-05-31 21:38:48Z bernardo.d.siqueira $
 */
@Component({
  templateUrl: './content.template.html'
})
@Injectable()
export class ReportsComponent implements OnInit {

  public static readonly REPORT_TYPE_CURRENT_CONSUMPTION = 'current_consumption';
  public static readonly REPORT_TYPE_BULK_OPERATIONS = 'bulk_operations';
  public static readonly REPORT_TYPE_THREE_LAST_CYCLES = 'three_last_cycles';
  public static readonly REPORT_TYPE_CALL_HISTORY = 'call_history';
  public static readonly REPORT_TYPE_BLOCK_SRV = 'block_srv';
  public static readonly REPORT_TYPE_VIVO_SYNC = 'vivo_sync';
  public static readonly REPORT_TYPE_PROC_ASYNC = 'proc_async';


  private reportTypes: any[] = [];
  private consumptionTypes: any[] = [];
  private detailTypes: any[] = [];

  private activeReportType: any;
  private activeConsumptionType: any;
  private activeDetailType: any;
  private activeStartDate: Date;
  private activeEndDate: Date;
  private activeLineNumber: string;

  private selectedReportType: any;
  private selectedConsumptionType: any;
  private selectedDetailType: any;
  private selectedStartDate: any;
  private selectedEndDate: any;
  private selectedLineNumber: string;
  public vivoSyncOnOff: boolean =false;
  public refresh: number = 0;

  private msisdnPattern: any = '^\\d{11}$';

  constructor(private alertService: AlertService, private bindComponent: BindComponentService) { //ALTERADO

  }

  ngOnInit() {
    this.bindComponent.set(BindComponentService.FILTER_ACTIVE_TAB, 'REPORTS_FILTER'); //ALTERADO
    this.createSearchOptions();
  }

  private createSearchOptions() {
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    if (!isNil(data)) {
      this.vivoSyncOnOff = data['vivoSyncOnOff'];
    } 

    this.reportTypes.push(
      {'id': ReportsComponent.REPORT_TYPE_CURRENT_CONSUMPTION, 'name': 'Consumo Atual'},
      {'id': ReportsComponent.REPORT_TYPE_THREE_LAST_CYCLES, 'name': 'Três Últimos Ciclos'},
      {'id': ReportsComponent.REPORT_TYPE_BULK_OPERATIONS, 'name': 'Relatório de Configuração'},
      {'id': ReportsComponent.REPORT_TYPE_CALL_HISTORY, 'name': 'Histórico de Chamadas'},
      {'id': ReportsComponent.REPORT_TYPE_BLOCK_SRV, 'name': 'Serviços de bloqueio'},
      {'id': ReportsComponent.REPORT_TYPE_PROC_ASYNC, 'name': 'Alterações em Andamento'}
    );

    if (this.vivoSyncOnOff) {
      this.reportTypes.push(
        { 'id': ReportsComponent.REPORT_TYPE_VIVO_SYNC, 'name': 'Vivo Sync Empresas' }
      )
    }
    
    this.consumptionTypes.push({'id': 'voice', 'name': 'Voz'}, {'id': 'data', 'name': 'Dados'}, {'id': 'voice_and_data', 'name': 'Voz + Dados'});
    this.detailTypes.push({'id': 'company', 'name': 'Conta'}, {'id': 'group', 'name': 'Grupo'}, {'id': 'line', 'name': 'Linha'});
    this.selectedReportType = this.reportTypes[0];
    this.selectedConsumptionType = this.consumptionTypes[0];
    this.selectedDetailType = this.detailTypes[0];
    this.searchInit();
    
    function isNil(value) {
      return value == null;
    }
  }

  


  private searchInit() {
    this.activeReportType = this.selectedReportType;
    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CURRENT_CONSUMPTION || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_THREE_LAST_CYCLES) {
       this.setAvtiveType();
    } else if ((this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BULK_OPERATIONS || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CALL_HISTORY)&& this.validDateRange()) {
      this.activeStartDate = moment().year(this.selectedStartDate.year).month(this.selectedStartDate.month - 1).date(this.selectedStartDate.day).hour(0).minute(0).second(0).millisecond(0).toDate();
      this.activeEndDate = moment().year(this.selectedEndDate.year).month(this.selectedEndDate.month - 1).date(this.selectedEndDate.day).hour(23).minute(59).second(59).millisecond(999).toDate();
    } else if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BLOCK_SRV || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_VIVO_SYNC || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_PROC_ASYNC) {
       this.setAvtiveType();
    } 
    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CALL_HISTORY) {
      this.activeLineNumber = this.selectedLineNumber;
    }
  }

  private search() {
    this.activeReportType = this.selectedReportType;
    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CURRENT_CONSUMPTION || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_THREE_LAST_CYCLES) {
       this.setAvtiveType();
    } else if ((this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BULK_OPERATIONS || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CALL_HISTORY)&& this.validDateRange()) {
      this.activeStartDate = moment().year(this.selectedStartDate.year).month(this.selectedStartDate.month - 1).date(this.selectedStartDate.day).hour(0).minute(0).second(0).millisecond(0).toDate();
      this.activeEndDate = moment().year(this.selectedEndDate.year).month(this.selectedEndDate.month - 1).date(this.selectedEndDate.day).hour(23).minute(59).second(59).millisecond(999).toDate();
    } else if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BLOCK_SRV || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_VIVO_SYNC || this.selectedReportType.id === ReportsComponent.REPORT_TYPE_PROC_ASYNC) {
       this.setAvtiveType();
    }
    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CALL_HISTORY) {
      this.activeLineNumber = this.selectedLineNumber;
    }
  }
  public setAvtiveType(){
    this.activeConsumptionType = this.selectedConsumptionType;
    this.activeDetailType = this.selectedDetailType;

    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_PROC_ASYNC) {
      this.refresh++;
    }
  }

  private validDateRange(): boolean {
    if (!this.selectedStartDate || !this.selectedEndDate) {
      this.alertService.warn('Preencha o período de pesquisa');
      return false;
    }
    let today = moment().hour(23).minute(59).second(59).millisecond(999);
    let activeStartDate = moment().year(this.selectedStartDate.year).month(this.selectedStartDate.month - 1).date(this.selectedStartDate.day).hour(0).minute(0).second(0).millisecond(0);
    let activeEndDate = moment().year(this.selectedEndDate.year).month(this.selectedEndDate.month - 1).date(this.selectedEndDate.day).hour(23).minute(59).second(59).millisecond(999);
    let threeMonthsAgo = moment().subtract(3, 'month').hour(0).minute(0).second(0).millisecond(0);
    let beforeDate = moment().year(2018).month(3).date(26).hour(0).minute(0).second(0).millisecond(0);
    moment().locale('pt-br');
    let diff  = activeEndDate.diff(activeStartDate,'month',true);
    if(activeStartDate.isBefore(beforeDate) && this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BULK_OPERATIONS){
      this.alertService.warn('Só é possível pesquisar a partir do dia 26/04/2018');
      return false;
    }
    if (activeStartDate.isAfter(today) || activeEndDate.isAfter(today)) {
      this.alertService.warn('Não é possível pesquisar no futuro');
      return false;
    }
    if (activeStartDate.isAfter(activeEndDate)) {
      this.alertService.warn('A data inicial deve ser menor que a data final');
      return false;
    }
    if ((activeStartDate.isBefore(threeMonthsAgo) || activeEndDate.isBefore(threeMonthsAgo)) && (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_BULK_OPERATIONS)) {
      this.alertService.warn('Só é possível pesquisar até 3 meses atrás');
      return false;
    }

    if ((diff>3)&&(this.selectedReportType.id === ReportsComponent.REPORT_TYPE_CALL_HISTORY)) {
      this.alertService.warn('Só é possível pesquisar no período de até 3 meses');
      return false;
    }

    return true;
  }

  private validateDate(): boolean {
    let valid: boolean = true;
    if (!this.activeStartDate || !this.activeEndDate || !this.activeStartDate == null || !this.activeEndDate == null) {
      valid = false;
    }
    return valid;
  }
  
  private autoSetDetailType() {
    if (this.selectedReportType.id === ReportsComponent.REPORT_TYPE_VIVO_SYNC) {
      this.selectedDetailType = this.detailTypes[1];
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/content.component.ts